import { useRef, useCallback } from "react";

export default function useDebounce(
  callback: Function,
  delay?: number,
): (...params: unknown[]) => void {
  const timerRef = useRef<NodeJS.Timeout>();

  const debouncedCallback = useCallback(
    (...params: unknown[]) => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => callback(...params), delay || 500);
    },
    [callback, delay],
  );

  return debouncedCallback;
}
